// Modal-----------------------------------------------------------------------------------------------
let modal = document.getElementById("myModal");
let openModalBtn = document.getElementById("openModalBtn");
let closeBtn = document.getElementsByClassName("close")[0];

let scrollPosition = 0;

// Function to lock body scroll but show scrollbar
function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.overflowY = "scroll"; // Ensure scrollbar stays visible
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = "100%"; // Prevent shifting
}

// Function to unlock body scroll
function unlockScroll() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.overflowY = ""; // Restore overflow behavior
    window.scrollTo(0, scrollPosition); // Restore scroll position
}

// When the user clicks the button, open the modal
openModalBtn.onclick = function () {
    lockScroll();
    modal.classList.add("show");
};

// When the user clicks on <span> (x), close the modal
closeBtn.onclick = function () {
    modal.classList.remove("show");
    unlockScroll();
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
    if (event.target == modal) {
        modal.classList.remove("show");
        unlockScroll();
    }
};

// Slider----------------------------------------------------------------------------------------------
// ----------------------------------------------------------------------------------------------------
let currentSlide = 1;
const totalSlides = 4;

// Function to show the slide based on the slide number
function showSlide(slideNumber) {
    const slides = document.querySelectorAll(".slide");

    // Hide all slides initially
    slides.forEach((slide) => {
        slide.style.display = "none";
    });

    // Show the current slide
    const targetSlide = document.getElementById(`slide-${slideNumber}`);
    if (targetSlide) {
        targetSlide.style.display = "block";
    }

    // Update the dots after showing the slide
    updateDots(slideNumber);

    // Show or hide the "Next" or "Previous" buttons depending on the slide
    document.getElementById('prev-btn').style.visibility = (slideNumber === 1) ? 'hidden' : 'visible';
    document.getElementById('next-btn').innerText = (slideNumber === totalSlides - 1) ? 'See Results' : 'Next';
    document.getElementById('next-btn').style.visibility = (slideNumber === totalSlides) ? 'hidden' : 'visible';
}

// Function to update the active dot
function updateDots(slideNumber) {
    const dots = document.querySelectorAll(".dot");

    dots.forEach((dot, index) => {
        if (index + 1 === slideNumber) {
            dot.classList.add("active");
        } else {
            dot.classList.remove("active");
        }
    });
}

// Function to go to the next slide
window.nextSlide = function () {
    if (currentSlide < totalSlides) {
        currentSlide++;
        showSlide(currentSlide);
    }
}

// Function to go to the previous slide
window.prevSlide = function () {
    if (currentSlide > 1) {
        currentSlide--;
        showSlide(currentSlide);
    }
}

// Function to go to a specific slide based on dot click
function goToSlide(slideNumber) {
    currentSlide = slideNumber;
    showSlide(currentSlide);
}

// Attach click event listeners to dots
const dots = document.querySelectorAll(".dot");
dots.forEach(dot => {
    dot.addEventListener("click", function () {
        const slideNumber = parseInt(this.getAttribute("data-slide"));
        goToSlide(slideNumber);
    });
});

// Initialize the first slide
showSlide(currentSlide);

// =========================== ALL VARIABLES FOR FINAL CALCULATIONS ====================================
let selectedGender = 'male';
let selectedAge = 25;
let selectedWeight = 80;
let selectedHeight = 170;
let selectedActivity = 'medium';
let selectedClimate = 'hot';
let selectedWater = 0;
let selectedCoffee = 0;
let selectedWine = 0;
let selectedEnergy = 0;

function updateResultFields() {
    const actualLiquidIntakeDiv = document.getElementById('actual-liquid-intake-div');
    const hydrationTargetDiv = document.getElementById('hydration-target-div');
    const hydrationTargetFromFluidsDiv = document.getElementById('hydration-target-from-fluids');
    const estimatedWaterFromFoodDiv = document.getElementById('estimated-water-from-food-div');
    const fluidTarget = document.getElementById('fluid-target');
    const dailyFluidIntake = document.getElementById('daily-fluid-intake');
    const hydrationGapDiv = document.getElementById('hydration-gap-div');

    // console.log("Selected Gender: ", selectedGender);
    // console.log("Selected Age: ", selectedAge);
    // console.log("Selected weight: ", selectedWeight);
    // console.log("Selected height: ", selectedHeight);
    // console.log("Selected activity: ", selectedActivity);
    // console.log("Selected climate: ", selectedClimate);
    // console.log("Weather:", selectedClimate);
    // console.log("Selected liquid: ", 
    //     (selectedWater+selectedSoda+selectedDietSoda+selectedFruitJuice+selectedCoffeeSugar+selectedCoffee+selectedWine+selectedBeer+selectedSport+selectedEnergy)
    // );

    const isMetric = selectedSystem === 'metric' ? true : false;
    
    // Calculate total water required
    const totalRequiredFluid = calculateWaterDeficit((selectedGender === 'breastfeeding' || selectedGender === 'pregnant') ? 'female' : selectedGender, selectedAge, selectedHeight, selectedWeight, selectedClimate, selectedActivity);
    hydrationTargetDiv.innerText = (totalRequiredFluid * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    estimatedWaterFromFoodDiv.innerText = ((totalRequiredFluid * 25 / 100) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    const hydrationTargetFromFluids = parseFloat(totalRequiredFluid - totalRequiredFluid * 25 / 100);
    hydrationTargetFromFluidsDiv.innerText = (hydrationTargetFromFluids * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    if (selectedAge > 10) {
        document.getElementById('required-400').innerText = parseFloat(hydrationTargetFromFluids / 0.4).toFixed(1) + " to " + parseFloat(hydrationTargetFromFluids / 0.32).toFixed(1);
        document.getElementById('required-600').innerText = parseFloat(hydrationTargetFromFluids / 0.6).toFixed(1) + " to " + parseFloat(hydrationTargetFromFluids / 0.5).toFixed(1);
        document.getElementById('required-div-600').style.display = "flex";
        document.getElementById('required-800').innerText = parseFloat(hydrationTargetFromFluids / 0.75).toFixed(1);
        document.getElementById('required-div-800').style.display = "flex";
        document.getElementById('required-1200').innerText = parseFloat(hydrationTargetFromFluids / 1.2).toFixed(1) + " to " + parseFloat(hydrationTargetFromFluids / 0.92).toFixed(1);
        document.getElementById('required-div-1200').style.display = "flex";
    } else {
        document.getElementById('required-400').innerText = parseFloat(hydrationTargetFromFluids / 0.4).toFixed(1) + " to " + parseFloat(hydrationTargetFromFluids / 0.32).toFixed(1);
        document.getElementById('required-div-600').style.display = "none";
        document.getElementById('required-div-800').style.display = "none";
        document.getElementById('required-div-1200').style.display = "none";
    }

    // Calculate actual water intake with liquid factor
    const actualLiquidIntake = (selectedWater * 0.25 * 1 + selectedCoffee * 0.125 * 0.85 + selectedWine * 0.125 * 0.6 + selectedEnergy * 0.25 * 1.2);
    actualLiquidIntakeDiv.innerText = (actualLiquidIntake * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    document.getElementById('selected-water').innerText = ((selectedWater * 0.25) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    document.getElementById('selected-coffee').innerText = ((selectedCoffee * 0.125 * 0.85) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    document.getElementById('selected-alcohol').innerText = ((selectedWine * 0.125 * 0.6) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    document.getElementById('selected-electrolyte').innerText = ((selectedEnergy * 0.25 * 1.2) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');

    // Calculate hydration status and update hydration gap
    const hydrationStatus = (parseFloat(hydrationTargetFromFluids) - parseFloat(actualLiquidIntake));
    fluidTarget.innerText = (hydrationTargetFromFluids * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    dailyFluidIntake.innerText = (actualLiquidIntake * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
    hydrationGapDiv.innerText = ((hydrationStatus >= 0 ? hydrationStatus : 0) * (isMetric ? 1000 : 33.814)).toFixed(0) + (isMetric ? ' ml' : ' oz');
}

// Gender selection------------------------------------------------------------------------
const maleImg = document.querySelector('.gender-input-field img[alt="Male"]');
const femaleImg = document.querySelector('.gender-input-field img[alt="Female"]');
const genderField = document.querySelector('.gender-input-field');

const iconsElement = document.getElementById('hydration-icons');

// Get asset paths from the data attributes
const maleUnselected = iconsElement.getAttribute('data-male-unselected');
const maleSelected = iconsElement.getAttribute('data-male-selected');
const femaleUnselected = iconsElement.getAttribute('data-female-unselected');
const femaleSelected = iconsElement.getAttribute('data-female-selected');


maleImg.src = maleSelected;
genderField.classList.add('hide-arrow');

// Function to create dropdown for female
function createFemaleDropdown() {
    const dropdown = document.createElement('select');
    dropdown.innerHTML = `
        <option value="female">&mdash;</option>
        <option value="pregnant">Pregnant</option>
        <option value="breastfeeding">Breastfeeding</option>
    `;
    dropdown.classList.add('female-options');
    dropdown.addEventListener('change', () => {
        selectedGender = dropdown.value;
        updateResultFields();
    });
    return dropdown;
}

maleImg.addEventListener('click', () => {
    // Reset to default view when male is selected
    maleImg.src = maleSelected;
    femaleImg.src = femaleUnselected;
    const dropdown = document.querySelector('.female-options');
    if (dropdown) {
        dropdown.classList.remove('show');
        setTimeout(() => dropdown.remove(), 200);
    }
    genderField.classList.add('hide-arrow');
    selectedGender = 'male'; // Update the gender selection
    updateResultFields();
});

femaleImg.addEventListener('click', () => {
    femaleImg.src = femaleSelected;
    maleImg.src = maleUnselected;

    if (!document.querySelector('.female-options')) {
        const dropdown = createFemaleDropdown();
        genderField.appendChild(dropdown);
        setTimeout(() => dropdown.classList.add('show'), 10);
        genderField.classList.remove('hide-arrow');
    }
    selectedGender = 'female'; // Update the gender selection
    updateResultFields();
});

// Age selection-----------------------------------------------------------------
const ageInput = document.getElementById('age');
const ageRange = document.getElementById('age-range');

ageInput.value = selectedAge;

// Update the age and range on number input change
ageInput.addEventListener('input', (e) => {
    if (e.target.value === '') {
        ageRange.value = ageRange.min;
        selectedAge = 3;
    } else {
        selectedAge = parseInt(e.target.value);
        ageRange.value = selectedAge;
    }

    selectedAge = selectedAge < 3 ? 3 : selectedAge;
    updateResultFields();
});

// Update the number input when the range slider is moved
ageRange.addEventListener('input', (e) => {
    selectedAge = parseInt(e.target.value);
    ageInput.value = selectedAge;
    updateResultFields();
});

// Weight selection-------------------------------------------------------------
let isKg = true;
const kgToLbFactor = 2.20462;
const minWeightKg = 35;
const maxWeightKg = 124;

const weightInput = document.getElementById('weight');
const weightUnitSpan = document.getElementById('weight-unit');
const weightDecrementBtn = document.getElementById('decrement-weight');
const weightIncrementBtn = document.getElementById('increment-weight');

// Update the weight value based on kg or lb
function updateWeightValue(amount) {
    let weight = parseFloat(weightInput.value);
    if (isKg) {
        weight = Math.min(maxWeightKg, Math.max(minWeightKg, weight + amount));
    } else {
        weight = weight / kgToLbFactor;
        weight = Math.min(maxWeightKg, Math.max(minWeightKg, weight + (amount / kgToLbFactor)));
    }
    weightInput.value = parseFloat(isKg ? weight : (weight * kgToLbFactor).toFixed(0));
    selectedWeight = weight;
    updateResultFields();

    // Update button colors
    updateButtonStyles(weight);
}

// Update weight from direct input changes
function handleInputChange() {
    let weight = parseFloat(weightInput.value);
    if (isNaN(weight)) return;

    weight = isKg ? weight : weight / kgToLbFactor;
    weight = Math.min(maxWeightKg, Math.max(minWeightKg, weight));
    selectedWeight = weight;
    updateResultFields();

    // Update button colors
    updateButtonStyles(weight);
}

// Change button styles based on the current weight
function updateButtonStyles(weight) {
    // If weight is at minimum, change decrement button color
    if (weight <= minWeightKg) {
        weightDecrementBtn.style.backgroundColor = '#fff';
        weightDecrementBtn.style.color = '#333333';
        weightDecrementBtn.style.border = '1px solid #333333';
    } else {
        weightDecrementBtn.style.backgroundColor = '';
        weightDecrementBtn.style.color = '';
        weightDecrementBtn.style.border = '';
    }

    // If weight is at maximum, change increment button color
    if (weight >= maxWeightKg) {
        weightIncrementBtn.style.backgroundColor = '#fff';
        weightIncrementBtn.style.color = '#333333';
        weightIncrementBtn.style.border = '1px solid #333333';
    } else {
        weightIncrementBtn.style.backgroundColor = '';
        weightIncrementBtn.style.color = '';
        weightIncrementBtn.style.border = '';
    }
}

// Handle decrement
weightDecrementBtn.addEventListener('click', () => {
    updateWeightValue(-1);
});

// Handle increment
weightIncrementBtn.addEventListener('click', () => {
    updateWeightValue(1);
});

// Listen for direct changes in the input field
weightInput.addEventListener('input', handleInputChange);

// Listen for system change and update the input and label accordingly
function toggleWeightUnit(isMetric) {
    isKg = isMetric;
    let weight = parseFloat(weightInput.value);
    weightInput.value = isMetric
        ? (weight / kgToLbFactor).toFixed(0)
        : (weight * kgToLbFactor).toFixed(0);
    weightUnitSpan.textContent = isMetric ? 'kg' : 'lb';
}

// Height selection-----------------------------------------------------------------------------
let isCm = true;
const cmToInchFactor = 0.393701;
const minHeightCm = 130;
const maxHeightCm = 230;

const heightInput = document.getElementById('height');
const heightUnitSpan = document.getElementById('height-unit');
const heightDecrementBtn = document.getElementById('decrement-height');
const heightIncrementBtn = document.getElementById('increment-height');

// Update the height value based on cm or inches
function updateHeightValue(amount) {
    let height = parseFloat(heightInput.value);
    if (isCm) {
        height = Math.min(maxHeightCm, Math.max(minHeightCm, height + amount));
    } else {
        height = height / cmToInchFactor;
        height = Math.min(maxHeightCm, Math.max(minHeightCm, height + (amount / cmToInchFactor)));
    }
    heightInput.value = parseFloat(isCm ? height : (height * cmToInchFactor).toFixed(0));
    selectedHeight = height;
    updateResultFields();

    // Update button colors
    updateHeightButtonStyles(height);
}

// Update height from direct input changes
function handleHeightInputChange() {
    let height = parseFloat(heightInput.value);
    if (isNaN(height)) return;

    height = isCm ? height : height / cmToInchFactor;
    height = Math.min(maxHeightCm, Math.max(minHeightCm, height));
    selectedHeight = height;
    updateResultFields();

    // Update button colors
    updateHeightButtonStyles(height);
}

// Change button styles based on the current height
function updateHeightButtonStyles(height) {
    // If height is at minimum, change decrement button color
    if (height <= minHeightCm) {
        heightDecrementBtn.style.backgroundColor = '#fff';
        heightDecrementBtn.style.color = '#333333';
        heightDecrementBtn.style.border = '1px solid #333333';
    } else {
        heightDecrementBtn.style.backgroundColor = '';
        heightDecrementBtn.style.color = '';
        heightDecrementBtn.style.border = '';
    }

    // If height is at maximum, change increment button color
    if (height >= maxHeightCm) {
        heightIncrementBtn.style.backgroundColor = '#fff';
        heightIncrementBtn.style.color = '#333333';
        heightIncrementBtn.style.border = '1px solid #333333';
    } else {
        heightIncrementBtn.style.backgroundColor = '';
        heightIncrementBtn.style.color = '';
        heightIncrementBtn.style.border = '';
    }
}

// Handle decrement
heightDecrementBtn.addEventListener('click', () => {
    updateHeightValue(-1);
});

// Handle increment
heightIncrementBtn.addEventListener('click', () => {
    updateHeightValue(1);
});

// Listen for direct changes in the input field
heightInput.addEventListener('input', handleHeightInputChange);

// Listen for system change and update the input and label accordingly
function toggleHeightUnit(isMetric) {
    isCm = isMetric;
    let height = parseFloat(heightInput.value);
    heightInput.value = isMetric
        ? (height / cmToInchFactor).toFixed(0)
        : (height * cmToInchFactor).toFixed(0);
    heightUnitSpan.textContent = isMetric ? 'cm' : 'in';
}

// Physical activity selection----------------------------------------------------------
const activityBars = document.querySelectorAll('.activity-bar');
const activityRange = document.getElementById('activity-range');
const selectedActivityText = document.getElementById('selected-activity');

function updateActivityBars(index) {
    activityBars.forEach((bar, idx) => {
        if (idx <= index) {
            bar.classList.add('active');
        } else {
            bar.classList.remove('active');
        }
    });
}

function updateActivity() {
    const index = this?.dataset?.index ? parseInt(this.dataset.index) : parseInt(activityRange.value);
    updateActivityBars(index);

    selectedActivity = activityBars[index].getAttribute('data-value');
    selectedActivityText.textContent = selectedActivity.charAt(0).toUpperCase() + selectedActivity.slice(1);
    activityRange.value = index;
    updateResultFields();
}

document.addEventListener('DOMContentLoaded', () => {
    updateActivity.call(document.querySelector('.activity-bar[data-value="moderate"]'));
});

activityBars.forEach((bar, index) => {
    bar.dataset.index = index;
    bar.addEventListener('click', updateActivity);
});

activityRange.addEventListener('input', () => {
    updateActivity.call({ dataset: { index: activityRange.value } });
});

// Climate selection----------------------------------------------------------
const climateSelect = document.getElementById('climate');

// Update the selected climate when a new climate is chosen
climateSelect.addEventListener('change', (e) => {
    selectedClimate = e.target.value;
    updateResultFields();
});

// Liquid taking-----------------------------------------------------------------------------------------------------
let isMl = true;
const minLiquid = 0;
const maxLiquid = 40;

function updateDrinkValue(drinkInput, minValue, maxValue, amount, icon, decrementBtn, incrementBtn) {
    let drinkValue = parseFloat(drinkInput.value);
    drinkValue = Math.min(maxValue, Math.max(minValue, drinkValue + amount));

    // Update the input value
    drinkInput.value = drinkValue;

    // Update display and button styles
    updateDrinkDisplay(drinkValue, minValue, drinkInput, icon);
    updateDrinkButtonStyles(drinkValue, minValue, maxValue, decrementBtn, incrementBtn);

    return drinkValue;
}

// Change button styles and display the icon if value is at minimum
function updateDrinkDisplay(value, minValue, drinkInput, icon) {
    if (value <= minValue) {
        drinkInput.style.display = 'none';
        icon.style.display = 'block';
    } else {
        drinkInput.style.display = 'block';
        icon.style.display = 'none';
    }
}

// Change button styles based on the current value
function updateDrinkButtonStyles(value, minValue, maxValue, decrementBtn, incrementBtn) {
    // If at minimum, change decrement button color
    if (value <= minValue) {
        decrementBtn.style.backgroundColor = '#fff';
        decrementBtn.style.color = '#333333';
        decrementBtn.style.border = '1px solid #333333';
    } else {
        decrementBtn.style.backgroundColor = '';
        decrementBtn.style.color = '';
        decrementBtn.style.border = '';
    }

    // If at maximum, change increment button color
    if (value >= maxValue) {
        incrementBtn.style.backgroundColor = '#fff';
        incrementBtn.style.color = '#333333';
        incrementBtn.style.border = '1px solid #333333';
    } else {
        incrementBtn.style.backgroundColor = '';
        incrementBtn.style.color = '';
        incrementBtn.style.border = '';
    }
}

// Water selection-----------------------------------------------------
const waterInput = document.getElementById('water');
const waterIcon = document.getElementById('water-icon');
const waterDecrementBtn = document.getElementById('decrement-water');
const waterIncrementBtn = document.getElementById('increment-water');

// Handle water decrement
waterDecrementBtn.addEventListener('click', () => {
    selectedWater = updateDrinkValue(waterInput, minLiquid, maxLiquid, -1, waterIcon, waterDecrementBtn, waterIncrementBtn);
    updateResultFields();
});

// Handle water increment
waterIncrementBtn.addEventListener('click', () => {
    selectedWater = updateDrinkValue(waterInput, minLiquid, maxLiquid, 1, waterIcon, waterDecrementBtn, waterIncrementBtn);
    updateResultFields();
});

// Initialize
updateDrinkDisplay(selectedWater, minLiquid, waterInput, waterIcon);
updateDrinkButtonStyles(selectedWater, minLiquid, maxLiquid, waterDecrementBtn, waterIncrementBtn);

// Coffee--------------------------------------------------------------
const coffeeInput = document.getElementById('coffee');
const coffeeIcon = document.getElementById('coffee-icon');
const coffeeDecrementBtn = document.getElementById('decrement-coffee');
const coffeeIncrementBtn = document.getElementById('increment-coffee');

// Handle coffee decrement
coffeeDecrementBtn.addEventListener('click', () => {
    selectedCoffee = updateDrinkValue(coffeeInput, minLiquid, maxLiquid, -1, coffeeIcon, coffeeDecrementBtn, coffeeIncrementBtn);
    updateResultFields();
});

// Handle coffee increment
coffeeIncrementBtn.addEventListener('click', () => {
    selectedCoffee = updateDrinkValue(coffeeInput, minLiquid, maxLiquid, 1, coffeeIcon, coffeeDecrementBtn, coffeeIncrementBtn);
    updateResultFields();
});

// Initialize
updateDrinkDisplay(selectedCoffee, minLiquid, coffeeInput, coffeeIcon);
updateDrinkButtonStyles(selectedCoffee, minLiquid, maxLiquid, coffeeDecrementBtn, coffeeIncrementBtn);

// Wine----------------------------------------------------------
const wineInput = document.getElementById('wine');
const wineIcon = document.getElementById('wine-icon');
const wineDecrementBtn = document.getElementById('decrement-wine');
const wineIncrementBtn = document.getElementById('increment-wine');

// Handle wine decrement
wineDecrementBtn.addEventListener('click', () => {
    selectedWine = updateDrinkValue(wineInput, minLiquid, maxLiquid, -1, wineIcon, wineDecrementBtn, wineIncrementBtn);
    updateResultFields();
});

// Handle wine increment
wineIncrementBtn.addEventListener('click', () => {
    selectedWine = updateDrinkValue(wineInput, minLiquid, maxLiquid, 1, wineIcon, wineDecrementBtn, wineIncrementBtn);
    updateResultFields();
});

// Initialize
updateDrinkDisplay(selectedWine, minLiquid, wineInput, wineIcon);
updateDrinkButtonStyles(selectedWine, minLiquid, maxLiquid, wineDecrementBtn, wineIncrementBtn);

// Energy ---------------------------------------------------------
const energyInput = document.getElementById('energy');
const energyIcon = document.getElementById('energy-icon');
const energyDecrementBtn = document.getElementById('decrement-energy');
const energyIncrementBtn = document.getElementById('increment-energy');

// Handle energy decrement
energyDecrementBtn.addEventListener('click', () => {
    selectedEnergy = updateDrinkValue(energyInput, minLiquid, maxLiquid, -1, energyIcon, energyDecrementBtn, energyIncrementBtn);
    updateResultFields();
});

// Handle energy increment
energyIncrementBtn.addEventListener('click', () => {
    selectedEnergy = updateDrinkValue(energyInput, minLiquid, maxLiquid, 1, energyIcon, energyDecrementBtn, energyIncrementBtn);
    updateResultFields();
});

// Initialize
updateDrinkDisplay(selectedEnergy, minLiquid, energyInput, energyIcon);
updateDrinkButtonStyles(selectedEnergy, minLiquid, maxLiquid, energyDecrementBtn, energyIncrementBtn);

// Listen for unit change (ml or oz) and update the input and label accordingly-----------------------------------------------------
const waterUnitSpan = document.getElementById('water-unit');
const coffeeUnitSpan = document.getElementById('coffee-unit');
const wineUnitSpan = document.getElementById('wine-unit');
const energyUnitSpan = document.getElementById('energy-unit');

function toggleLiquidUnit(isMetric) {
    isMl = isMetric;
    waterUnitSpan.textContent = isMetric ? '(250ml/glass)' : '(8.5oz/glass)';
    coffeeUnitSpan.textContent = isMetric ? '(125ml/glass)' : '(4.2oz/glass)';
    wineUnitSpan.textContent = isMetric ? '(125ml/glass)' : '(4.2oz/glass)';
    energyUnitSpan.textContent = isMetric ? '(250ml/glass)' : '(8.5oz/glass)';
}

// Calculate water loss----------------------------------------------------------------------------
function calculateWaterDeficit(gender, age, height, weight, climate, activityLevel) {
    // Convert string inputs to lowercase for case-insensitive matching
    gender = gender.toLowerCase();
    climate = climate.toLowerCase();
    activityLevel = activityLevel.toLowerCase();

    // Step 1: Calculate Body Surface Area (BSA) using DuBois formula
    const BSA = 0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425);

    // Step 2: Estimate Skin Evaporation Loss based on climate
    const evaporationRates = {
        "hot": 650,
        "moderate": 450,
        "cool": 300
    };
    const skinEvaporationLoss = BSA * evaporationRates[climate];

    // Step 3: Calculate Caloric Expenditure using Mifflin-St Jeor equation
    let BMR;
    if (gender === "male") {
        BMR = 10 * weight + 6.25 * height - 5 * age + 5;
    } else if (gender === "female") {
        BMR = 10 * weight + 6.25 * height - 5 * age - 161;
    }

    const activityFactors = {
        "low": 1.2,
        "medium": 1.55,
        "high": 1.9
    };
    const calories = BMR * activityFactors[activityLevel];

    // Step 4: Calculate Respiratory Water Loss
    const respiratoryLoss = calories * 0.12;

    // Step 5: Calculate Metabolic Water Production
    const metabolicWaterProduction = calories * 0.12;

    // Step 6: Calculate Skin Sweat Loss based on climate and activity level
    const sweatRates = {
        "hot": 12,
        "moderate": 8,
        "cool": 5
    };
    const sweatLoss = weight * sweatRates[climate];  // Assuming 1 hour of activity

    // Step 7: Calculate Fixed Water Loss
    const faecalLoss = 200;
    const urineLoss = 1000;

    // Step 8: Calculate Total Water Deficit
    const waterDeficit = skinEvaporationLoss + respiratoryLoss + sweatLoss + faecalLoss + urineLoss - metabolicWaterProduction;

    return (waterDeficit / 1000).toFixed(1);
}

const button = document.getElementById('toggle-btn');
const settingsPanel = document.getElementById('settings-panel');

let selectedSystem = "metric";
let isSettingsOpen = true;
button.style.boxShadow = "none";
const closeIcon = iconsElement.getAttribute('data-close-icon');
const settingIcon = iconsElement.getAttribute('data-setting-icon');

function toggleSettings() {
    if (!isSettingsOpen) {
        button.innerHTML = `<img src=${closeIcon} alt='X'>`;
        settingsPanel.classList.add('visible');
        isSettingsOpen = true;
        button.style.boxShadow = "none";
        settingsPanel.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
    } else {
        button.innerHTML = `<img src=${settingIcon} alt='S'>`;
        settingsPanel.classList.remove('visible');
        isSettingsOpen = false;
        button.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
        settingsPanel.style.boxShadow = "none";
    }
}

function toggleSystem(system) {
    const metricBtn = document.getElementById('metric-btn');
    const imperialBtn = document.getElementById('imperial-btn');

    if (system === 'metric') {
        metricBtn.classList.add('active');
        imperialBtn.classList.remove('active');
        setUnits('metric');
    } else {
        imperialBtn.classList.add('active');
        metricBtn.classList.remove('active');
        setUnits('imperial');
    }
}

function setUnits(system) {
    if (system === 'metric') {
        selectedSystem = "metric";
        toggleWeightUnit(true);
        toggleHeightUnit(true);
        toggleLiquidUnit(true);
        updateResultFields();
    } else {
        selectedSystem = "imperial";
        toggleWeightUnit(false);
        toggleHeightUnit(false);
        toggleLiquidUnit(false);
        updateResultFields();
    }
}